import Svg, { SvgProps } from './Svg';

export default function WebsiteUnavailableIcon({ ...props }: SvgProps) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 41 40"
      {...props}>
      <path
        d="M9.99695 7.29969C15.7976 1.49906 25.2023 1.49906 31.0029 7.29969C36.8035 13.1003 36.8035 22.505 31.0029 28.3056L21.9141 37.3944C21.1331 38.1754 19.8668 38.1754 19.0857 37.3944L9.99696 28.3056C4.19633 22.505 4.19633 13.1003 9.99695 7.29969Z"
        fill="url(#paint0_linear_197_10845)"
      />
      <circle
        cx="20.501"
        cy="17.8154"
        r="8.2959"
        stroke="#2A197D"
        strokeWidth="3"
      />
      <path
        d="M26.5967 12.0234L14.5287 24.0914"
        stroke="#2A197D"
        strokeWidth="3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_197_10845"
          x1="5.64648"
          y1="38.8086"
          x2="5.64648"
          y2="2.94922"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD2B9" />
          <stop offset="1" stopColor="#FF6D6D" />
          <stop offset="1" stopColor="#FF6D6D" />
          <stop offset="1" stopColor="#FF6D6D" />
        </linearGradient>
      </defs>
    </Svg>
  );
}
